import React, { ReactNode } from 'react';
import { withLocalePrefix } from 'shared/utils/translation';
import type { DataCollectionRuleInterface } from '../../data_collection_rules/data_collection_rule';
import EditEmailRecipients from '../edit/email_recipients';
import EmptyState from '../../shared/empty_state';
import EmailRecipient from './email_recipient';

const t = withLocalePrefix('gdpr.data_collection_rules.view.table');

type Props = {
  editing: boolean;
  rule: DataCollectionRuleInterface;
  setRule: any;
};

const hasEmailRecipients = (rule: DataCollectionRuleInterface) =>
  rule.email_recipients.length;

export default function EmailRecipients({
  editing,
  rule,
  setRule,
}: Props): ReactNode {
  if (editing) {
    return <EditEmailRecipients rule={rule} setRule={setRule} />;
  } else if (!hasEmailRecipients(rule)) {
    // @ts-expect-error - TS2769 - No overload matches this call.
    return <EmptyState emphasize>{t('rule.no_email_recipients')}</EmptyState>;
  } else {
    return rule.email_recipients.map((recipient) => (
      <EmailRecipient key={recipient} recipient={recipient} />
    ));
  }
}
